import React, { useRef, useEffect, useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import './VideoModal.css';

const VideoModal = ({ show, onHide, videoSrc = 'dQw4w9WgXcQ' }) => {
  const videoRef = useRef(null);
  const isYouTube = !videoSrc.includes('.') && videoSrc.length > 5;

  const handleClose = useCallback(() => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    onHide();
  }, [onHide]);

  useEffect(() => {
    if (!show && videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [show]);

  useEffect(() => {
    if (!show || !isYouTube) return undefined;

    const handleYouTubeMessage = (event) => {
      if (event.origin !== 'https://www.youtube.com') return;
      try {
        const data = JSON.parse(event.data);
        if (data.event === 'onStateChange' && data.info === 0) {
          onHide();
        }
      } catch {
        // ignore non-JSON postMessage payloads
      }
    };

    window.addEventListener('message', handleYouTubeMessage);
    return () => window.removeEventListener('message', handleYouTubeMessage);
  }, [show, isYouTube, onHide]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      className="video-modal"
      backdropClassName="video-modal-backdrop"
    >
      <Modal.Body className="video-modal-body">
        <button
          type="button"
          className="video-modal-close"
          onClick={handleClose}
          aria-label="Close video"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <div className="video-container">
          {isYouTube ? (
            <iframe
              src={`https://www.youtube.com/embed/${videoSrc}?autoplay=1&enablejsapi=1`}
              title="How It Works"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <video
              ref={videoRef}
              src={videoSrc}
              controls
              autoPlay
              onEnded={handleClose}
              className="w-100"
              style={{ maxHeight: '80vh' }}
            >
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VideoModal;
